export function initMobileLanguageSwitcher() {
  const mobileSwitcher = document.querySelector('.pl-lang-switcher-mobile');
  if (!mobileSwitcher) return;

  const head = mobileSwitcher.querySelector('.pl-lang-switcher-mobile__head');
  const body = mobileSwitcher.querySelector('.pl-lang-switcher-mobile__body');

  head.addEventListener('click', (e) => {
    e.stopPropagation();
    body.classList.toggle('hidden');
  });

  document.addEventListener('click', (e) => {
    if (!mobileSwitcher.contains(e.target)) {
      body.classList.add('hidden');
    }
  });
}
